// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PromoCodeResponse

import { DiscountType } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type PromoCodeApiResponse = {
	id: string;
	code: string;
	description: string;
	discountType: DiscountType;
	discountValue: number;
	validityStart: string | null;
	validityEnd: string | null;
	validityDates: string[] | null;
	usageLimit: number | null;
	limitPerCustomer: number | null;
	minAmount: number | null;
	newCustomersOnly: boolean;
	applyToAllBookings: boolean;
	isActive: boolean;
	color: string;
	createdAt: string;
	publishStart: string | null;
	publishEnd: string | null;
	archivedAt: string | null;
	applyToGiftcard: boolean;
	applyToPackage: boolean;
	applyToOffers: string[];
	applyToSessions: string[];
	applyToActivities: string[];
	applyToProducts: string[];
};

export type PromoCode = {
	id: string;
	code: string;
	description: string;
	discountType: DiscountType;
	discountValue: number;
	validityStart: DateTime | null;
	validityEnd: DateTime | null;
	validityDates: string[] | null;
	usageLimit: number | null;
	limitPerCustomer: number | null;
	minAmount: number | null;
	newCustomersOnly: boolean;
	applyToAllBookings: boolean;
	isActive: boolean;
	color: string;
	createdAt: DateTime;
	publishStart: DateTime | null;
	publishEnd: DateTime | null;
	archivedAt: DateTime | null;
	applyToGiftcard: boolean;
	applyToPackage: boolean;
	applyToOffers: string[];
	applyToSessions: string[];
	applyToActivities: string[];
	applyToProducts: string[];
};

export function hydratePromoCode(data: PromoCodeApiResponse): PromoCode {
	return {
		...data,
		validityStart: DateTimefromISO(data.validityStart),
		validityEnd: DateTimefromISO(data.validityEnd),
		createdAt: DateTimefromISO(data.createdAt)!,
		publishStart: DateTimefromISO(data.publishStart),
		publishEnd: DateTimefromISO(data.publishEnd),
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}